module.exports = __webpack_public_path__ + "images/dingtalk/ad20160530/1-40b93c6ed3d61c049632029b100ad055.jpg";